resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';/* The callback registered in registerScrollingFunction is
 * passed in 2 paramaters when it runs, event and scroll distance as px w/o unit.
 * Callback(event, scrollTop) { //function }
 */

function _ScrollingLayout() {
  // setup
  this._setup = false;
  this._keyIndex = 0;
  this._scrollingFunctions = {};
  this.extends = [_ResponsiveLayout];

  //elements
  this._$window = $(window);

  this.init = function() {};
  this.initAllReady = function() {};

  this._registerOnViewCallback = function(event, scrollTop, key) {
    if((scrollTop + this._scrollingFunctions[key].windowHeight) >= this._scrollingFunctions[key].nodePosition.top) {
      this._scrollingFunctions[key].subCallback();
      this.destroyScrollingFunction(key);
    }
  };

  this.registerOnView = function(callback, $node) {
    var key = this.registerScrollingFunction(this._registerOnViewCallback.bind(this), { $node: $node, subCallback: callback });
    this.registerResponsiveFunction($.proxy(this._setMeasurements, this, key), null, null);
  };

  this._setMeasurements = function(key) {
    this._scrollingFunctions[key].nodePosition = this._scrollingFunctions[key].$node.offset();
    this._scrollingFunctions[key].windowHeight = this._$window.height();
  };

  this.registerScrollingFunction = function(callback, options) {
    this._keyIndex++;

    // create scrolling event if this is the first thing to register a scrolling function
    if (!this._setup) {
      this._setup = true;
      this._createScrollingEvent();
    }

    // create new object
    this._scrollingFunctions[this._keyIndex] = {};

    // passthrough node as a jquery object
    if(options.$node) {
      this._scrollingFunctions[this._keyIndex].$node = options.$node;
      this._setMeasurements(this._keyIndex);
    }

    // passthrough origional callback as a secondary callback to run through _registerOnViewCallback
    if(options.subCallback) {
      this._scrollingFunctions[this._keyIndex].subCallback = options.subCallback;
    }

    // set callback for scrolling event to run
    this._scrollingFunctions[this._keyIndex].callback = callback;
    return this._keyIndex;
  };

  this.destroyScrollingFunction = function(key) {
    this._scrollingFunctions[key].callback = null;

    // check for remaining scrolling Functions
    for (var i = 0; i < Object.keys(this._scrollingFunctions).length; i++) {
      var key2 = Object.keys(this._scrollingFunctions)[i];

      if(typeof this._scrollingFunctions[key2].callback === "function") {
        return true;
      }
    }

    // COMMENTED OUT TILL ALL SCROLL EVENTS ARE UPDATED TO USE _ScrollingLayout
    // if no remaining scrolling functions delete scroll event and reset
    // this._setup = false;
    // this._$window.unbind('scroll');
  };

  this._createScrollingEvent = function() {
    this._$window.on("scroll", this._runScrollingFunctions.bind(this));
  };

  this._runScrollingFunctions = function(e) {
    var scrollTop = this._$window.scrollTop();
    for (var i = 0; i < Object.keys(this._scrollingFunctions).length; i++) {
      var key = Object.keys(this._scrollingFunctions)[i];

      if(typeof this._scrollingFunctions[key].callback === "function") {
        this._scrollingFunctions[key].callback(e, scrollTop, key);
      }
    }
  };
}
